import { AbstractControl } from '@angular/forms';

export function noEmptyTrimmedStringValidator(control: AbstractControl) {
  if (!control.value) {
    return null;
  }

  const isValid = control.value.trim().length > 0;
  return isValid ? null : { emptyString: true };
}
